import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-TM5BP4JT.mjs";
import "./chunk-CDQIA6O3.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
